import { useRouter } from 'next/router';

const RedirectToMyTeam = () => {
  const router = useRouter();
  router.push('/my-team/pick?liveRankError=true');
  return null;
};

export default RedirectToMyTeam;
